import axios from "axios";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { endpoints } from "../../helpers/endpoints";
import { bodyRequest, headers, bodyProvider } from "../../helpers/utils";
import { useSearchParams } from "react-router-dom";

import "./style.scss";
import { isDesktop, isTablet } from "react-device-detect";
import {
  isDuplicateFunc,
  isDuplicateUnvail,
  isMoreExpense,
  isUnavailableFunc,
  isValidHex,
} from "./helper";
import loadingImg from "../../assets/images/loading.gif";

function CalendarBook() {
  const localizer = momentLocalizer(moment);
  const [service, setService] = useState([]);
  const [product, setProduct] = useState();
  const [dailyRates, setDailyRates] = useState([]);
  const [providers, setProviders] = useState();
  const [services, setServices] = useState([]);
  const [searchParams] = useSearchParams();
  const [empty, setEmpty] = useState(false);
  const [error, setError] = useState(false);
  // const [currentYear, setCurrentYear] = useState(moment().format("Y"));
  const [currentDate, setCurrentDate] = useState(new Date());
  const [currentMonth, setCurrentMonth] = useState(
    parseInt(moment().format("M"))
  );
  const [loading, setLoading] = useState(false);
  const clickRef = useRef(null);

  const serviceName = searchParams.get("service");
  const productName = searchParams.get("product");
  const distributor = searchParams.get("distributor");
  const provider = searchParams.get("provider");
  const color = searchParams.get("color");
  const title = searchParams.get("title");
  const maxData = searchParams.get("data");

  const detailRequest = bodyRequest;

  detailRequest.request.Output.Availability.NumberOfDays = 40;

  if (serviceName) {
    detailRequest.request.Filter.Names = [`%${serviceName}%`];
  }
  if (distributor) {
    detailRequest.request.ShortName = distributor;
    bodyProvider.request.ShortName = distributor;
  }

  if (provider) {
    bodyProvider.request.Filter.Codes = [provider];
  }

  const getProvider = () => {
    axios.post(endpoints.search, bodyProvider).then((res) => {
      if (res.data?.Entities?.length > 0) {
        setProviders(res?.data?.Entities[0]);
      }
    });
  };

  const checkDatePrice = () => {
    let rates = [];

    service?.Children?.forEach((child, index) => {
      if (productName) {
        if (productName !== child.Name) {
          return;
        } else {
          setProduct(child);
        }
      }
      if (child.Availability.Calendar.DailyRates) {
        child.Availability.Calendar.DailyRates.forEach((rate) => {
          if (rate.Rate) {
            const newRate = {
              id: index + 1,
              start: new Date(rate?.Date),
              end: new Date(rate?.Date),
              title: `From $${rate.Rate}`,
              product: child?.Id,
            };

            const isUnavailable = isUnavailableFunc(rates, newRate);

            if (isUnavailable) {
              rates = rates.filter(
                (existingRate) =>
                  existingRate.start.getTime() !== newRate.start.getTime()
              );
            }

            let isDuplicate = isDuplicateFunc(dailyRates, newRate);

            let isMoreExpensive = isMoreExpense(dailyRates, newRate);

            if (rates?.length > 0) {
              if (!isDuplicate) {
                isDuplicate = isDuplicateFunc(rates, newRate);
              }

              isMoreExpensive = isMoreExpense(rates, newRate);

              if (isMoreExpensive) {
                rates = rates.filter(
                  (existingRate) =>
                    existingRate.start.getTime() !== newRate.start.getTime()
                );
                rates.push(newRate);
              }
            }
            if (!isDuplicate && !isMoreExpensive) {
              rates.push(newRate);
            }
          } else {
            let isDuplicateUnavailable = isDuplicateUnvail(dailyRates, rate);

            if (rates?.length > 0 && !isDuplicateUnavailable) {
              isDuplicateUnavailable = isDuplicateUnvail(rates, rate);
            }

            if (
              parseInt(moment(new Date(rate?.Date)).format("M")) ===
                currentMonth &&
              !isDuplicateUnavailable
            ) {
              rates.push({
                id: `unavailable-${rate?.Date}-single`,
                start: new Date(rate?.Date),
                end: new Date(rate?.Date),
                title: `NOT AVAILABLE`,
                unavailable: true,
              });
            }
          }
        });
      }
    });

    setDailyRates((dailyRate) => [...dailyRate, ...rates]);
  };

  const checkMultipleDatePrice = () => {
    let rates = [];

    services?.map((service) => {
      service?.Children?.forEach((child, index) => {
        if (productName) {
          if (productName !== child.Name) {
            return;
          }
          setProduct(child);
          setService(service);
        }
        if (child.Availability.Calendar.DailyRates) {
          child.Availability.Calendar.DailyRates.forEach((rate) => {
            if (rate.Rate) {
              const newRate = {
                id: index + 1,
                start: new Date(rate?.Date),
                end: new Date(rate?.Date),
                title: `From $${rate.Rate}`,
                product: child?.Id,
              };

              const isUnavailable = isUnavailableFunc(rates, newRate);

              if (isUnavailable) {
                rates = rates.filter(
                  (existingRate) =>
                    existingRate.start.getTime() !== newRate.start.getTime()
                );
              }

              let isDuplicate = isDuplicateFunc(dailyRates, newRate);

              let isMoreExpensive = isMoreExpense(dailyRates, newRate);

              if (rates?.length > 0) {
                if (!isDuplicate) {
                  isDuplicate = isDuplicateFunc(rates, newRate);
                }

                isMoreExpensive = isMoreExpense(rates, newRate);
                if (isMoreExpensive) {
                  rates = rates.filter(
                    (existingRate) =>
                      existingRate.start.getTime() !== newRate.start.getTime()
                  );
                  rates.push(newRate);
                }
              }

              if (
                !isDuplicate &&
                !isMoreExpensive &&
                parseInt(moment(newRate.start).format("M")) === currentMonth
              ) {
                rates.push(newRate);
              }
            } else {
              const isAvail =
                rates.some(
                  (existingRate) =>
                    existingRate.start.getTime() ===
                      new Date(rate?.Date).getTime() &&
                    !existingRate?.unavailable
                ) ||
                dailyRates.some(
                  (existingRate) =>
                    existingRate.start.getTime() ===
                      new Date(rate?.Date).getTime() &&
                    !existingRate?.unavailable
                );
              if (!isAvail) {
                let isDuplicateUnavailable = isDuplicateUnvail(
                  dailyRates,
                  rate
                );

                if (rates?.length > 0 && !isDuplicateUnavailable) {
                  isDuplicateUnavailable = isDuplicateUnvail(rates, rate);
                }
                if (
                  parseInt(moment(new Date(rate?.Date)).format("M")) ===
                    currentMonth &&
                  !isDuplicateUnavailable
                ) {
                  rates.push({
                    id: `unavailable-${rate?.Date}-multiple`,
                    start: new Date(rate?.Date),
                    end: new Date(rate?.Date),
                    title: `NOT AVAILABLE`,
                    unavailable: true,
                  });
                }
              }
            }
          });
        }
      });
    });

    setDailyRates((dailyRate) => [...dailyRate, ...rates]);
  };

  const getData = (id) => {
    if (id) {
      detailRequest.request.Filter.Names = [`%${id}%`];
    }
    setLoading(true);
    axios
      .post(endpoints.search, detailRequest, { headers: headers })
      .then((response) => {
        if (id) {
          setServices((prevServices) => [
            ...prevServices,
            response.data.Entities[0],
          ]);
        } else if (serviceName) {
          setService(response.data.Entities[0]);
          if (response.data.Entities.length === 0) {
            setEmpty(true);
          }
        } else {
          setServices(response.data?.Entities);
        }
      })
      .catch(() => {
        setError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // const getHolidays = () => {
  //   const holidays = [];
  //   axios
  //     .get(
  //       `https://data.gov.au/data/api/action/datastore_search?resource_id=4d4d744b-50ed-45b9-ae77-760bc478ad75&limit=30`
  //     )
  //     .then((res) => {
  //       res?.data?.result?.records?.map((item, index) => {
  //         if (item?.Date) {
  //           const dateString = item?.Date;
  //           const year = parseInt(dateString.slice(0, 4), 10);
  //           const month = parseInt(dateString.slice(4, 6), 10) - 1;
  //           const day = parseInt(dateString.slice(6, 8), 10);
  //           const date = new Date(year, month, day);
  //           let isDuplicate = dailyRates.some((existingRate) => {
  //             return existingRate.start.getTime() === date.getTime();
  //           });
  //           let isDuplicateHoliday = holidays.some((existing) => {
  //             return existing.title === item["Holiday Name"];
  //           });
  //           if (!isDuplicate && !isDuplicateHoliday) {
  //             holidays?.push({
  //               id: index + 1,
  //               start: date,
  //               end: date,
  //               title: item["Holiday Name"],
  //               holiday: true,
  //             });
  //           }
  //         }
  //       });
  //       setDailyRates((dailyRate) => [...dailyRate, ...holidays]);
  //     });
  // };

  useEffect(() => {
    if (maxData) {
      bodyRequest.request.Paging.PageSize = parseInt(maxData);
      bodyProvider.request.Paging.PageSize = parseInt(maxData);
    }
    if (provider) {
      getProvider();
    } else {
      getData();
    }

    const headers = document.querySelectorAll(".rbc-header");
    headers.forEach((header) => {
      header.style.backgroundColor = validColor ? validColor : "#ee2d24";
      header.style.color = "white";
    });

    return () => {
      window.clearTimeout(clickRef?.current);
    };
  }, []);

  useEffect(() => {
    checkDatePrice();
  }, [service]);

  useEffect(() => {
    if (providers?.Children?.length > 0) {
      providers?.Children?.map((child) => {
        getData(child?.Name);
      });
    }
  }, [providers]);

  useEffect(() => {
    if (!serviceName || services?.length === providers?.Children?.length) {
      checkMultipleDatePrice();
    }
  }, [services]);

  // useEffect(() => {
  //   getHolidays();
  // }, [currentYear]);

  const validColor = color ? isValidHex(color) : null;

  const rangeChange = (range) => {
    if (range) {
      detailRequest.request.Output.Availability.StartDate = range.start;
      let month = parseInt(moment(range.start).format("M"));
      const date = moment(range.start).format("D");

      if (date > 1) {
        month = month + 1;

        if (month === 13) {
          month = 1;
        }
      }
      // setCurrentYear(moment(range.end).format("Y"));
      setCurrentMonth(month);
      if (provider) {
        setServices([]);
        providers?.Children?.map((child) => {
          getData(child?.Name);
        });
      } else {
        getData();
      }
    }
  };

  const handleNavigate = (date) => {
    if (moment(date).isBefore(moment(today).startOf("month"))) {
      return;
    }
    setCurrentDate(date);
  };

  const handleClickEvent = (event) => {
    if (!event?.holiday && !event.unavailable) {
      if (service || provider || productName) {
        window
          .open(
            `https://book.txa.com.au/v4/Pages/Availability.aspx?exl_dn=${
              distributor || "aaa_mywebsite"
            }&exl_bs=${
              distributor || "aaa_mywebsite"
            }&exl_lng=en-AU&exl_cur=AUD&exl_grp=acc${
              service?.length > 0 ? `&pgid=${service?.Id}` : ""
            }${product ? `&exl_prd=${product?.Id}` : ""}${
              provider ? `&exl_psn=${providers?.Code}` : ""
            }&exl_dte=${moment(event?.start).format("YYYY-MM-DD")}`,
            "_blank"
          )
          .focus();
      } else {
        window
          .open(
            `https://book.txa.com.au/v4/Pages/Search.aspx?exl_dn=${
              distributor || "aaa_mywebsite"
            }&exl_bs=${distributor || "aaa_mywebsite"}`,
            "_blank"
          )
          .focus();
      }
    }
  };

  const handleClickSlot = (slotInfo) => {
    const selectedDate = slotInfo.start.toDateString(); // Convert date to string for comparison

    // Find events that match the selected date
    const event = dailyRates.filter(
      (item) => new Date(item.start).toDateString() === selectedDate
    );

    console.log(event);

    if (!event?.holiday && !event.unavailable) {
      if (service || provider || productName) {
        window
          .open(
            `https://book.txa.com.au/v4/Pages/Availability.aspx?exl_dn=${
              distributor || "aaa_mywebsite"
            }&exl_bs=${
              distributor || "aaa_mywebsite"
            }&exl_lng=en-AU&exl_cur=AUD&exl_grp=acc${
              service?.length > 0 ? `&pgid=${service?.Id}` : ""
            }${product ? `&exl_prd=${product?.Id}` : ""}${
              provider ? `&exl_psn=${providers?.Code}` : ""
            }&exl_dte=${moment(event?.start).format("YYYY-MM-DD")}`,
            "_blank"
          )
          .focus();
      } else {
        window
          .open(
            `https://book.txa.com.au/v4/Pages/Search.aspx?exl_dn=${
              distributor || "aaa_mywebsite"
            }&exl_bs=${distributor || "aaa_mywebsite"}`,
            "_blank"
          )
          .focus();
      }
    }
  };

  const dayPropGetter = (date) => {
    let style = {
      backgroundColor: "#fff",
    };
    if (moment(date).isSame(new Date(), "day")) {
      style = {
        border: `2px solid ${validColor ? validColor : "#0f199f"}`,
        backgroundColor: "#fff",
      };
    }

    const hasEvent = dailyRates.some(
      (event) =>
        moment(event.start).isSame(moment(date), "day") && event.unavailable
    );

    if (hasEvent) {
      style = {
        backgroundColor: "#E6E6E6",
      };
    }

    if (date < new Date(today.setHours(0, 0, 0, 0))) {
      style = {
        backgroundColor: "#f5f5f5",
      };
    }

    return { className: "", style };
  };

  if (error) {
    return <div>Something went wrong</div>;
  }

  const today = new Date();

  const CustomToolbar = (toolbar) => {
    const goToBack = () => {
      toolbar.onNavigate("PREV");
    };

    const goToNext = () => {
      toolbar.onNavigate("NEXT");
    };

    const goToToday = () => {
      toolbar.onNavigate("TODAY");
    };

    return (
      <div className="rbc-toolbar text-sm lg:text-base">
        <div className="rbc-toolbar-navigation min-w-[200px] mb-2 lg:mb-0 flex justify-center lg:justify-start">
          <button
            onClick={goToBack}
            className="rbc-back-button transition text-xs lg:text-base"
          >
            ← {/* Left arrow */}
          </button>
          <button
            onClick={goToToday}
            className="rbc-today-button mx-2 transition text-xs lg:text-base"
          >
            Today
          </button>
          <button
            onClick={goToNext}
            className="rbc-next-button transition text-xs lg:text-base"
          >
            → {/* Right arrow */}
          </button>
        </div>
        <div className="rbc-toolbar-label order-3 lg:!order-2 text-sm lg:text-lg">
          {toolbar.label}
        </div>
        <div className="min-w-[200px] text-center order-2 lg:!order-3 lg:!text-end text-sm lg:text-base">
          Click Date to View
        </div>
      </div>
    );
  };

  const MyEventComponent = (event) => {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          cursor: "pointer",
        }}
      >
        {event.title}
      </div>
    );
  };

  const [selectedEvents, setSelectedEvents] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const handleShowMore = (events) => {
    setSelectedEvents(events);
    setShowModal(true);
  };

  return (
    <main>
      {loading && (
        <section className="bg-white w-[99vw] z-10 h-screen fixed bg-opacity-50 left-0 top-0 flex justify-center items-center">
          <div>
            <img src={loadingImg} alt="Loading" className="w-20 h-20" />
          </div>
        </section>
      )}
      <section className="p-2 lg:!p-8">
        <h2 className="text-lg lg:text-3xl font-bold mb-3 text-center">
          {title || "Availability Summary"}
        </h2>
        {empty ? (
          <div>Product Not Found</div>
        ) : (
          <Calendar
            localizer={localizer}
            events={dailyRates}
            startAccessor="start"
            endAccessor="end"
            style={{ height: isDesktop || isTablet ? 600 : 400 }}
            views={{ month: true }}
            dayPropGetter={dayPropGetter}
            onShowMore={handleShowMore}
            min={new Date(today.setHours(0, 0, 0, 0))}
            onNavigate={handleNavigate}
            popup
            date={currentDate}
            components={{
              toolbar: CustomToolbar,
              event: MyEventComponent,
            }}
            onSelectSlot={handleClickSlot}
            onRangeChange={rangeChange}
            onSelectEvent={(event) => handleClickEvent(event)}
            eventPropGetter={(event) => {
              let className = "";
              let newStyle = {
                backgroundColor: "transparent",
                textAlign: "center",
                color: validColor ? validColor : "#000000",
                fontSize: isDesktop || isTablet ? "14px" : "8px",
              };
              if (event.holiday) {
                newStyle.backgroundColor = "transparent";
                newStyle.color = "red";
                newStyle.fontSize = isDesktop || isTablet ? "14px" : "8px";
                className = "holiday";
              }

              if (event.unavailable) {
                newStyle.backgroundColor = "#E6E6E6";
                newStyle.color = "#999999";
                newStyle.fontSize = isDesktop || isTablet ? "13px" : "7px";
              }

              return {
                className,
                style: newStyle,
              };
            }}
          />
        )}
      </section>

      {showModal && (
        <div className="modal">
          <h3>More Events</h3>
          <ul>
            {selectedEvents.map((event, index) => (
              <li key={index}>{event.title}</li>
            ))}
          </ul>
          <button onClick={() => setShowModal(false)}>Close</button>
        </div>
      )}
    </main>
  );
}

export default CalendarBook;
